import Vue from 'vue'
import Vuex from 'vuex'
import { baseUrl } from '../constants'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    username:null,
    accessToken: null,
    refreshToken: null,
    isStaff: null,
    currentCourse: null,
    // api: 'http://localhost:8000/'
    api: 'https://vmott29.in.tum.de/'
  },
  mutations: {
    updateStorage (state, { access, refresh, username, isStaff }) {
      state.accessToken = access
      state.refreshToken = refresh
      state.username = username
      state.isStaff = isStaff
    },
    destroyToken (state) {
      state.accessToken = null;
      state.refreshToken = null;
      state.username = null;
      state.isStaff = null;
      localStorage.clear();
      localStorage.removeItem('accessToken');
      Vue.$axios.defaults.headers.common['Authorization'] = null;
    },
    updateCurrentCourse(state, currentCourse) {
      state.currentCourse = currentCourse
    }
  },
  getters: {
    loggedIn (state) {
      return state.accessToken != null
    },
    username (state) {
      return state.username
    },
    isStaff (state) {
      return state.isStaff
    },
    api (state) {
      return state.api
    }
  },
  actions: {
    //methods for my own login if we decided to implement it ourself
    userLogin (context, userCredentials){
      return Vue.$axios
        .post(baseUrl.concat("api/token/"), {
          username: userCredentials.username,
          password: userCredentials.password
        })
        .then((response: any) => {
          context.commit('updateStorage', {access: response.data.access, refresh: response.data.refresh});
          Vue.$axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.access;
          localStorage.setItem('accessToken', response.data.access );
        })
        .catch(() => {
          throw "Etwas ist schief gelaufen. Probieren Sie es bitte erneut.";
        });
      
    },
    userLogout (context) {
      context.commit('destroyToken');
    }
  },
  modules: {
  }
})
